import React, { useMemo } from 'react';
import { SicrediLogoTheme } from '../../libraries/SicrediLogoThemes';
import './SicrediLogo.scss';
const rootClassName = 'sicredi-logo';

interface SicrediLogoProps {
  height?: number | string;
  theme?: SicrediLogoTheme;
  hideLetters?: boolean;
}

export const SicrediLogo = (props: SicrediLogoProps) => {
  const primaryColor = useMemo(() => {
    return props.theme === SicrediLogoTheme.Verde ? '#3fa110' : '#FFFFFF';
  }, [props.theme]);

  const secondaryColor = useMemo(() => {
    return props.theme === SicrediLogoTheme.Verde ? '#146e37' : '#DDDDDD';
  }, [props.theme]);

  return (
    <div className={rootClassName}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        height={props.height}
        viewBox='0 0 269.602 61.781'
      >
        <g id='Logo' transform='translate(-203.255 -204.669)'>
          <g id='Logo_SVG' transform='translate(203.255 204.669)'>
            <path
              d='M545.016-655.026c25.67-3.323,29.51.974,31.057-1.519.573-2.378-8.566-9.913-23.092-13.208A31.085,31.085,0,0,0,545.016-655.026Z'
              transform='translate(-545.016 679.415)'
              fill={primaryColor}
            />
            <path
              d='M555.672-673.008c17.62,16.674,16.7,21.488,18.88,21.144,3.7-.717.2-17.505-3.5-22.863A31.513,31.513,0,0,0,555.672-673.008Z'
              transform='translate(-536.133 675.021)'
              fill={primaryColor}
            />
            <path
              d='M572.178-672.687c7.735,4.7,10.085,9.368,10.085,9.34-2.292,6.876-10.686,17.1-13.523,15.185C567.164-649.825,571.347-653.664,572.178-672.687Z'
              transform='translate(-525.536 676.964)'
              fill={primaryColor}
            />
            <path
              d='M587.367-662c-16.015,11.832-19.023,9.655-19.539,12.176.63,4.24,16.875,2.578,19.711.774C587.625-649.022,588.771-654.379,587.367-662Z'
              transform='translate(-525.999 685.873)'
              fill={primaryColor}
            />
            <path
              d='M586.64-645.595a32.313,32.313,0,0,1-9.626,9.512c-4.039-1.49-14.812-13.236-12.807-16.961C566.47-655.078,565.782-650.9,586.64-645.595Z'
              transform='translate(-529.225 692.904)'
              fill={primaryColor}
            />
            <path
              d='M563.472-655.049c2.808.516-.344,4.641,8.251,24.725a32.122,32.122,0,0,1-15.194-1.12C555.306-639.435,559.633-654.963,563.472-655.049Z'
              transform='translate(-535.595 691.672)'
              fill={primaryColor}
            />
            <path
              d='M545.205-648.986c7.191-6.418,23.407-13.093,25.642-9.77,1.117,2.664-3.323,1.174-17.075,24.066C553.771-634.661,547.01-640.763,545.205-648.986Z'
              transform='translate(-544.861 687.843)'
              fill={primaryColor}
            />
          </g>
          <g id='Interno' transform='translate(203.566 204.963)'>
            <path
              d='M1321.144,3363.676a39.183,39.183,0,0,0-4.648,12.868c5.906,6.9,6.561,10.131,8.008,10.019C1328.468,3386.17,1324.911,3368.931,1321.144,3363.676Z'
              transform='translate(-1286.53 -3363.676)'
              fill={secondaryColor}
            />
            <path
              d='M1024.246,3484.361a49.909,49.909,0,0,0,9.042,13.446c11.233-.064,11.266,1.405,13.612.165C1048.911,3495.557,1038.042,3487.141,1024.246,3484.361Z'
              transform='translate(-1016.417 -3474.961)'
              fill={secondaryColor}
            />
            <path
              d='M925.458,3742.666c5.15,1.912,17.352,1.22,17.343,1.212,6.973-9.022,8.19-8.692,8.428-10.547C951.2,3729.329,935.6,3733.649,925.458,3742.666Z'
              transform='translate(-925.458 -3704.056)'
              fill={secondaryColor}
            />
            <path
              d='M1188.664,3868.228c-.025.062,8.894-5.486,10.636-11.413-2.83-10.767-1.359-12.1-3.669-12.3C1193.109,3844.235,1187.894,3855.321,1188.664,3868.228Z'
              transform='translate(-1168.172 -3808.2)'
              fill={secondaryColor}
            />
            <path
              d='M1381.043,3885.678a39.114,39.114,0,0,1,1.415,13.153c-8.038-4.867-14.333-15.117-12.337-17.514C1372.366,3880.452,1371.936,3881.984,1381.043,3885.678Z'
              transform='translate(-1335.271 -3842.116)'
              fill={secondaryColor}
            />
            <path
              d='M1472.415,3760.207c-9.375,5.237-9.713,3.963-9.951,5.7.575,4.246,16.85,2.621,19.725.787A33.569,33.569,0,0,0,1472.415,3760.207Z'
              transform='translate(-1420.947 -3730.177)'
              fill={secondaryColor}
            />
            <path
              d='M1491.717,3537.359c-5.178.335-11.383,3.546-11.4,3.548-1.4,8.3-3.314,10.19-2.123,11.635C1481.7,3554.912,1490.036,3542.959,1491.717,3537.359Z'
              transform='translate(-1435.301 -3524.037)'
              fill={secondaryColor}
            />
          </g>
          <path
            id='Caminho_17'
            className={props.hideLetters ? `${rootClassName}-hide-letters` : ''}
            d='M10.1-443.483c-9.423,0-13.509,2.213-14.738,11.284-.7,5.5,1.692,8.706,7.779,11.223l8.323,3.078c2.517.936,3.239,1.05,2.888,3.8-.527,3.512-2.579,3.876-7.9,3.876-6.385.114-5.945.176-13.377,0l-1.216,7.829c5.587.152,12.69.413,15.5.413,10.71,0,16.132-3.046,17.3-12.118.761-6.028-2.17-9.539-8.349-11.587L8.843-428.34c-2.926-1.112-3.186-1.549-2.806-3.742.5-3.333,1.837-3.537,6.11-3.479,4.437-.023,10.621-.023,14.12,0l1.14-7.922C17.3-443.567,10.1-443.483,10.1-443.483Zm23.745-.092-1.179,8.039,9.977.023,1.126-8.115Zm3.705,41.21,4.348-29h-9.93l-4.3,29Zm24-29.784c-10.359,0-15.01,4.243-16.532,15.011-1.58,11.12,3,15.468,13.3,15.468,3.687,0,8.095-.228,11.553-1.368l.95-6.841a95.169,95.169,0,0,1-10.717.608c-4.975,0-5.628-1.206-4.75-8.171.819-6.73,4.026-7.107,9.235-7.107,2.107,0,5,.034,8.392.092l.995-6.477C67.562-432.377,65.092-432.035,61.557-432.149Zm39.772.691c-5.048-.331-9.44,1.627-13.771,5.724l-.092-5.724-7.838.049-4.407,29.13h9.952l2.477-16.983c2.871-1.974,4.976-3.524,9.535-2.964Zm17.462-.767c-10.641-.418-17.04,2.391-18.555,14.784-1.406,12.013,4.213,16.015,15.589,15.772,3.921,0,10.017-.8,13.646-2.324l-1.23-5.87c-3.453.41-9.606.746-12.415.746-3.629,0-5.394-1.1-5.394-4.066l9.8-.684c7.433-.527,10.886-2.97,11.705-8.589C132.818-428.6,129.47-432.035,118.791-432.226Zm3.458,9.577c-.76,2.28-1.293,2.877-4.219,3.111l-6.84.537c.995-5.853,2.392-6.119,6.84-6.119C121.659-425.177,122.484-425.341,122.249-422.649Zm47.689-20.784h-9.952l-.869,6.1c-.293,2.048-.422,3.542-.87,5.861a67.447,67.447,0,0,0-9.859-.669c-6.438,0-11.974,2.417-13.73,15.059-1.522,11.53,2.435,15.409,8.58,15.409a18.318,18.318,0,0,0,12.551-5.417l-.092,4.807,7.92.049Zm-25.132,26.047c1.334-8,2.378-7.862,7.856-8.112h4.531l-1.882,11.754c-3.219,2.809-5.468,4.239-8.453,4.3C143.991-409.329,143.928-410.889,144.806-417.385Zm31.31-26.138-1.188,8.009,9.907-.037,1.177-8.065Zm3.694,41.243,4.407-29.13h-9.894l-4.407,29.13Z'
            fill={primaryColor}
          />
        </g>
      </svg>
    </div>
  );
};

SicrediLogo.defaultProps = {
  height: 45,
  theme: SicrediLogoTheme.Verde,
  hideLetters: false
};
